const offersCategoryDesktop = name => name && name === 'Sale & Offers';

export const blackFridayCategory = name => name && name === 'Black Friday';

export default offersCategoryDesktop;
